import * as MasterAction from './MasterAction';
import baseReducer from '../../utilities/BaseReducer';
import jwt_decode from 'jwt-decode';

export const initialState = {};

const MasterReducer = baseReducer(initialState, {
  [MasterAction.REQUEST_MASTERDATA_FINISHED](state, action) {
    return {
      ...state,
      master: action.payload,
    };
  },
  [MasterAction.REQUEST_USER_ROLE_UPDATE](state, action) {
    return {
      ...state,
      sysUserData: action.payload,
    };
  },
  [MasterAction.REQUEST_ROLE_FINISHED](state, action) {
    let token = action.payload && action.payload.data && action.payload.data.length > 0 && action.payload.data[0].sysUserXToken;
    let decode_token = jwt_decode(token);
    localStorage.setItem('access_token', token);
    return {
      ...state,
      sysUserData: decode_token && JSON.stringify(decode_token),
    };
  },
  [MasterAction.REQUEST_SERVER_DATETIME_FINISHED](state, action) {
    return {
      ...state,
      serverDateTime: action.payload,
    };
  },
});

export default MasterReducer;
